<template>
  <div
    class="relative group flex items-center text-app-color md:-ml-25"
    :class="settings.bookView === 'List' ? 'mt-20 mb-20': ''"
  >
    <i
      v-if="!isMobile"
      class="handle icon-drag_indicator text-app-color mr-5 opacity-0 text-20 cursor-grab group-hover:opacity-50 hover:opacity-100 anim-opacity"
    />

    <div>
      <input
        v-if="isEdit"
        ref="titleInputRef"
        v-model="title"
        type="text"
        class="font-Inter w-full rounded text-18 md:text-23 bg-hover-book outline-none font-extrabold leading-none"
        @blur="onBlur"
        @keydown.enter="onBlur"
      >

      <p v-else class="font-Inter text-grey-350 font-bold cursor-grab text-18 md:text-23 leading-none">{{ book.title }}</p>
    </div>

    <div
      class="flex items-center opacity-0 group-hover:opacity-100 anim-opacity"
      :class="isDarkMode ? 'text-grey-250' : 'text-black-color'"
    >
      <ButtonModule
        ref="button"
        prefix="icon-delete md:opacity-50 hover:opacity-100"
        class="ml-5 py-0"
        @click="remove"
      />

      <ButtonModule
        ref="button"
        prefix="icon-edit md:opacity-50 hover:opacity-100"
        class="pl-0 py-0"
        @click="edit"
      />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, nextTick, ref } from 'vue'
import { useStore } from 'vuex'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default defineComponent({
  components: {
    ButtonModule
  },

  props: {
    book: Object
  },

  setup (props) {
    const { state, dispatch, getters } = useStore()

    // data
    let timer = null
    const isEdit = ref(false)

    // refs
    const titleInputRef = ref(null)

    // computed
    const settings = computed(() => state.settings.settings)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isMobile = computed(() => getters.isMobile)

    const title = computed({
      get: () => {
        return props.book.title
      },
      set: (value) => {
        clearTimeout(timer)

        if (value.trim() !== '') {
          timer = setTimeout(() => {
            dispatch('editBook', {
              ...props.book,
              title: value
            })
          }, 300)
        }
      }
    })

    // functions
    function onBlur () {
      isEdit.value = false
    }

    function edit () {
      isEdit.value = true

      nextTick(() => {
        titleInputRef.value.focus()
        titleInputRef.value.setSelectionRange(0, 9999)
      })
    }

    function remove () {
      dispatch('deleteBook', {
        id: props.book.id,
        isSection: true
      })
    }

    function setFocus () {
      isEdit.value = true

      nextTick(() => {
        titleInputRef.value.focus()
        titleInputRef.value.setSelectionRange(0, 9999)
      })
    }

    return {
      title,
      isEdit,
      // refs
      titleInputRef,
      // computed
      settings,
      isDarkMode,
      isMobile,
      // function
      onBlur,
      edit,
      remove,
      setFocus
    }
  }
})
</script>
